import classNames from "classnames";
import React, { useLayoutEffect } from 'react';
import $ from "jquery";
import styles from "./TextEditor.module.css";
import {
  useVideoWrapper,
  useAccordionWrapper,
  useOldAccordionWrapper,
  useSectionAccordionWrapper,
  useBlockquote,
  useExpandoButton,
  useAnimateOnScroll,
  useScrollStats
} from "utils";

export interface TextEditorProps {
  className?: string;
  data: string;
  DisplaySimplifiedBannerDesktop?: boolean;
  DisplaySimplifiedBannerMobile?: boolean;
  isDesktop?: boolean;
  style?: { [key: string]: string | number }
}

const _TextEditor = ({
  isDesktop,
  DisplaySimplifiedBannerDesktop,
  DisplaySimplifiedBannerMobile,
  data,
  className = "",
  style,
  ...props
}: TextEditorProps) => {
  useVideoWrapper();
  useAccordionWrapper();
  useOldAccordionWrapper();
  useSectionAccordionWrapper();
  useBlockquote();
  useExpandoButton();
  useAnimateOnScroll();
  useScrollStats();


  // If SimplifiedBanner Component is rendered, display children 1-4
  useLayoutEffect(() => {
    if (isDesktop && DisplaySimplifiedBannerDesktop) {
      $(".TextEditor-1 div *:nth-child(1)").css({ opacity: 1 });
      $(".TextEditor-1 div *:nth-child(2)").css({ opacity: 1 });
      $(".TextEditor-1 div *:nth-child(3)").css({ opacity: 1 });
      $(".TextEditor-1 div *:nth-child(4)").css({ opacity: 1 });
    }
    if (!isDesktop && DisplaySimplifiedBannerMobile) {
      $(".TextEditor-1 div *:nth-child(1)").css({ opacity: 1 });
      $(".TextEditor-1 div *:nth-child(2)").css({ opacity: 1 });
      $(".TextEditor-1 div *:nth-child(3)").css({ opacity: 1 });
      $(".TextEditor-1 div *:nth-child(4)").css({ opacity: 1 });
    }

  }, []);

  return (
    <div
      style={{ ...style }}
      className={classNames(styles.texteditor, className)}
      {...props}
    >
      <div className="postcontent" dangerouslySetInnerHTML={{ __html: data }}></div>
    </div>
  );
};

export const TextEditor = React.memo(_TextEditor);
